module.exports = __webpack_public_path__ + "assets/img/travel5.93e86aad.png";